import { resolveEmbedHost } from '../../core/bridge/embed';
import { parseOriginList } from '../../core/bridge/post-message/protocol';

function isFramed() {
    try {
        return window.self !== window.top;
    } catch {
        return true;
    }
}

const allowlist = parseOriginList(import.meta.env.VITE_EMBED_HOST_ORIGINS || '');

// Read once at boot: embed mode is a property of how the app was loaded, not
// navigable route state (the hash router owns everything after '#').
const resolved = resolveEmbedHost({
    search: window.location.search,
    allowlist,
    ancestorOrigins: window.location.ancestorOrigins ? Array.from(window.location.ancestorOrigins) : null,
    isFramed: isFramed(),
});

export const embedConfig = Object.freeze({
    isEmbed: resolved.isEmbed,
    hostOrigin: resolved.hostOrigin,
    rejectionReason: resolved.reason,
    allowlist: Object.freeze(allowlist),
});
